module.exports = __webpack_public_path__ + "hipchat-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/hipchat-logo.png
// module id = 1258
// module chunks = 74